import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { TourCard } from "@/components/Cards";

export default function Tours() {
  const [tours, setTours] = useState([]);
  useEffect(() => { api.get("/tours").then((r) => setTours(r.data)); }, []);
  return (
    <div>
      <Seo title="Tours & Experiences" description="Book guided tours and experiences in RiNo — mural walking tours, brewery crawls, e-bike rides, and First Friday VIP gallery tours in Denver." />
      <PageHeader overline="Do RiNo" title="Tours & Experiences" subtitle="See the district through a local's eyes — mural walks, brewery crawls, e-bike rides, and more." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="tours-list">
          {tours.map((t, i) => <TourCard key={t.id} t={t} index={i} />)}
        </div>
      </div>
    </div>
  );
}
